<template>
  <div :class="getClass()">
    <div class="bordered-container-header" v-if="title">{{ title }}</div>
    <slot name="default" />
  </div>
</template>

<script>
export default {
  name: "BorderedContainer",
  props: {
    title: String,
    inverseGray: Boolean,
    secondary: Boolean,
    error: Boolean,
    positive: Boolean
  },
  methods: {
    getClass() {
      if (this.secondary) return "bordered-container aev-secondary";
      else if (this.error) return "bordered-container aev-error";
      else if (this.positive) return "bordered-container aev-positive";
      else if (this.inverseGray) return "bordered-container aev-inverse-gray";
      return "bordered-container";
    }
  }
};
</script>

<style lang='scss' scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.bordered-container {
  position: relative;
  background-color: white;
  border-radius: $border-radius;
  border: 1px solid $gray-lighten-1;

  overflow: hidden;

  .bordered-container-header {
    padding: $base-padding;
    background-color: $gray-lighten-2;
    color: $primary;
    font-weight: 600;
  }

  &.aev-inverse-gray {
    border: 1px solid $primary;
    background-color: $gray-lighten-3;

    .bordered-container-header {
      background-color: $primary;
      color: white;
    }
  }

  &.aev-secondary {
    border: 1px solid $secondary-lighten-3;
    background-color: white;

    .bordered-container-header {
      background-color: $secondary-lighten-4 !important;
      color: $secondary !important;
    }
  }

  &.aev-error {
    border: 1px solid $error-lighten-3;

    .bordered-container-header {
      background-color: $error-lighten-2 !important;
      color: $error !important;
    }
  }

  &.aev-positive {
    border: 1px solid $positive-lighten-2;

    .bordered-container-header {
      background-color: $positive-lighten-3 !important;
      color: $positive !important;
    }
  }
}
</style>
